module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"bulk":"Bulk Edit","clear":"Clear","cssnext":"Any {0} color feature can be used here.","download":"Download","restore":"Restore","save":"Save changes","varcomponent":"Component Variables","vargeneral":"General Variables","varmodified":"Modified variable","varnormal":"Normal variable","varreference":"Reference variable"},"ja":{"bulk":"編集","clear":"クリア","cssnext":"{0} で使える任意の色が利用できます。","download":"ダウンロード","restore":"もとに戻す","save":"保存","varcomponent":"コンポーネント変数","vargeneral":"共通変数","varmodified":"変更済み","varnormal":"未変更","varreference":"他の変数に依存"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/yaml-loader!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/TRCustomizer.vue
// module id = QYEI
// module chunks = 1